import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { environment } from 'environments/environment';
@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  UserURL = environment.UserURL;
  AdminUrl = environment.AdminURL;
  AuthURL = environment.AuthURL;
  socket:any;
  socket1:any;
  socket2:any;
  constructor() {
    // this.socket= (io as any)(this.AuthURL, { transports: ['websocket', 'polling', 'flashsocket'] });
    // this.socket1= (io as any)(this.AdminUrl, { transports: ['websocket', 'polling', 'flashsocket'] });
    // this.socket2= (io as any)(this.UserURL, { transports: ['websocket', 'polling', 'flashsocket'] });
   }
 
  listen(eventName:string){
    return new Observable((subscriber)=>{
      this.socket.on(eventName,(data)=>{
        subscriber.next(data)
      })
    });
  }

  emit(eventName:string,data:any){
    this.socket.emit(eventName,data)
  }
  listenAdmin(eventName:string){
    return new Observable((subscriber)=>{
      this.socket1.on(eventName,(data)=>{
        subscriber.next(data)
      })
    });
  }

  emitAdmin(eventName:string,data:any){
    this.socket1.emit(eventName,data)
  }
  listenUser(eventName:string){
    return new Observable((subscriber)=>{
      this.socket2.on(eventName,(data)=>{
        subscriber.next(data)
      })
    });
  }

  emitUser(eventName:string,data:any){
    this.socket2.emit(eventName,data)
  }
}
